<standard-skip-nav-link />

@if (transitionState() === "idle" && widthCategory() !== undefined) {
  <ng-container
    *ngTemplateOutlet="
      registerTemplate;
      context: {
        registerNavTemplates: registerNavTemplates,
      }
    "
  />

  <div class="overflow-hidden d-flex flex-grow-1" [inert]="isOverlayOpen()">
    @if (hasNavSide() && sideEdge() === "start") {
      @let state = navSideVisibilityState();
      <div
        [attr.data-bs-theme]="sideColorMode"
        class="nav-side-collapser-content-wrapper"
        [class.animate]="animate()"
        [class.minimized]="state === 'minimized'"
        [class.expanded]="state === 'expanded'"
        [class.collapsed]="state === 'collapsed'"
        [inert]="state === 'collapsed' || isNavSideInert()"
      >
        <ng-container
          *ngTemplateOutlet="
            navSideContent;
            context: { minimized: navSideMinimized() }
          "
        />

        @if (navSideResizable()) {
          <standard-resize-side
            side="end"
            [target]="hostEl"
            property="--bs-w-sidenav"
            [minWidth]="navSideResizableMin()"
            [maxWidth]="navSideResizableMax()"
          />
        }
      </div>
    }

    <div class="d-flex flex-column flex-grow-1 flex-shrink-1">
      @if (
        navTopLogoTemplate ||
        navTopStartActionsTemplate ||
        navTopMiddleLogoTemplate ||
        navTopEndActionsTemplate
      ) {
        <standard-nav-top
          [attr.data-bs-theme]="topColorMode"
          [class]="topStyleClass ?? ''"
        >
          @if (navTopLogoTemplate || hasNavSide()) {
            <ng-template #logo>
              <ng-container
                *ngTemplateOutlet="
                  navTopLogoTemplate;
                  context: {
                    hasNavSide: hasNavSide(),
                    navSideExpanded: navSideExpanded(),
                    navSideMinimized: navSideMinimized(),
                    toggleNavSide: onToggleNavSide,
                    colorMode: topColorMode,
                  }
                "
              />
            </ng-template>
          }

          @if (
            widthCategory() !== undefined &&
            widthCategory()! > topStartToSideStartMaxSize &&
            navTopStartActionsTemplate
          ) {
            <ng-template #startActions>
              <ng-container
                *ngTemplateOutlet="
                  navTopStartActionsTemplate;
                  context: {
                    hasNavSide: hasNavSide(),
                    navSideExpanded: navSideExpanded(),
                    navSideMinimized: navSideMinimized(),
                    toggleNavSide: onToggleNavSide,
                    variant: StandardNavLinkDropdownVariants.TopNav,
                    colorMode: topColorMode,
                  }
                "
              />
            </ng-template>
          }

          @if (navTopMiddleLogoTemplate) {
            <ng-template #middleLogo>
              <ng-container
                *ngTemplateOutlet="
                  navTopMiddleLogoTemplate;
                  context: {
                    hasNavSide: hasNavSide(),
                    navSideExpanded: navSideExpanded(),
                    navSideMinimized: navSideMinimized(),
                    toggleNavSide: onToggleNavSide,
                    colorMode: topColorMode,
                  }
                "
              />
            </ng-template>
          }

          @if (
            widthCategory() !== undefined &&
            widthCategory()! > topEndToSideEndMaxSize &&
            navTopEndActionsTemplate
          ) {
            <ng-template #endActions>
              <ng-container
                *ngTemplateOutlet="
                  navTopEndActionsTemplate;
                  context: {
                    hasNavSide: hasNavSide(),
                    navSideExpanded: navSideExpanded(),
                    navSideMinimized: navSideMinimized(),
                    toggleNavSide: onToggleNavSide,
                    variant: StandardNavLinkDropdownVariants.TopNav,
                    colorMode: topColorMode,
                  }
                "
              />
            </ng-template>
          }
        </standard-nav-top>
      }

      <div
        #contentScroller
        [class.overflow-y-auto]="scrollContent()"
        [class.scroll-container]="scrollContent()"
        class="d-flex flex-column flex-grow-1"
      >
        <main class="flex-grow-1" [inert]="isContentInert()">
          <standard-skip-nav-content />
          <ng-content />
        </main>

        @if (navBottomTemplate) {
          <div [attr.data-bs-theme]="bottomColorMode">
            <ng-container *ngTemplateOutlet="navBottomTemplate" />
          </div>
        }
      </div>
    </div>

    @if (hasNavSide() && sideEdge() === "end") {
      @let state = navSideVisibilityState();
      <div
        [attr.data-bs-theme]="sideColorMode"
        class="nav-side-collapser-content-wrapper"
        [class.animate]="animate()"
        [class.minimized]="state === 'minimized'"
        [class.expanded]="state === 'expanded'"
        [class.collapsed]="state === 'collapsed'"
        [inert]="state === 'collapsed' || isNavSideInert()"
      >
        <ng-container
          *ngTemplateOutlet="
            navSideContent;
            context: { minimized: navSideMinimized() }
          "
        />

        @if (navSideResizable()) {
          <standard-resize-side
            side="start"
            [target]="hostEl"
            property="--bs-w-sidenav"
            [minWidth]="navSideResizableMin()"
            [maxWidth]="navSideResizableMax()"
          />
        }
      </div>
    }
  </div>

  @if (shouldRenderNavSides()) {
    @let bgState = navSideOverlayBgVisibilityState();
    <div
      role="presentation"
      class="side-overlay position-fixed top-0 h-100 w-100 overflow-hidden bg-dark bg-opacity-50 nav-side-overlay-bg"
      [class.expanded]="allowNavSideAnimationIn() && bgState === 'expanded'"
      [class.collapsed]="!allowNavSideAnimationIn() || bgState === 'collapsed'"
      [inert]="!allowNavSideAnimationIn() || bgState === 'collapsed'"
      (click)="onToggleNavSide(false)"
    ></div>

    @let overlayState = navSideOverlayContentVisibilityState();
    @switch (sideEdge()) {
      @case ("start") {
        <div
          [attr.data-bs-theme]="sideColorMode"
          class="side-overlay position-fixed top-0 vh-100 bg-body text-body shadow nav-side-overlay-content-start"
          [class.expanded-full]="
            allowNavSideAnimationIn() && overlayState === 'expandedFull'
          "
          [class.expanded]="
            allowNavSideAnimationIn() && overlayState === 'expanded'
          "
          [class.collapsed]="
            !allowNavSideAnimationIn() || overlayState === 'collapsed'
          "
          [inert]="!allowNavSideAnimationIn() || overlayState === 'collapsed'"
          style="width: var(--bs-w-sidenav)"
          pFocusTrap
          [pFocusTrapDisabled]="!navSideOverlayed() || !navSideExpanded()"
        >
          <ng-container
            *ngTemplateOutlet="navSideContent; context: { minimized: false }"
          />
        </div>
      }

      @case ("end") {
        <div
          [attr.data-bs-theme]="sideColorMode"
          class="side-overlay position-fixed top-0 end-0 vh-100 bg-body text-body shadow nav-side-overlay-content-end"
          [class.expanded-full]="
            allowNavSideAnimationIn() && overlayState === 'expandedFull'
          "
          [class.expanded]="
            allowNavSideAnimationIn() && overlayState === 'expanded'
          "
          [class.collapsed]="
            !allowNavSideAnimationIn() || overlayState === 'collapsed'
          "
          [inert]="!allowNavSideAnimationIn() || overlayState === 'collapsed'"
          style="width: var(--bs-w-sidenav)"
          pFocusTrap
          [pFocusTrapDisabled]="!navSideOverlayed() || !navSideExpanded()"
        >
          <ng-container
            *ngTemplateOutlet="navSideContent; context: { minimized: false }"
          />
        </div>
      }
    }
  }
}

<ng-template #navSideContent let-minimized="minimized">
  @let state = navSideVisibilityState();

  <standard-nav-side
    #navSide
    class="h-100 nav-side-collapser-content bg-body text-body"
    [class.border-start]="sideEdge() === 'end'"
    [class.border-end]="sideEdge() === 'start'"
    [class.minimized]="state === 'minimized'"
    [class.expanded]="state === 'expanded'"
    [class.collapsed]="state === 'collapsed'"
    [headerStyleClass]="
      `border-bottom h-header ${navSideHeaderStyleClass ?? ''}`
    "
    [preStartActionsStyleClass]="navSidePreStartActionsStyleClass ?? ''"
    [startActionsStyleClass]="`py-3 ${navSideStartActionsStyleClass ?? ''}`"
    [endActionsStyleClass]="`py-3 ${navSideEndActionsStyleClass ?? ''}`"
  >
    @if (navSideContentTemplate) {
      <ng-template #content>
        <ng-container
          *ngTemplateOutlet="
            navSideContentTemplate;
            context: {
              hasNavSide: hasNavSide(),
              navSideExpanded: navSideExpanded(),
              toggleNavSide: onToggleNavSide,
              minimized: minimized,
              variant: minimized
                ? StandardNavLinkDropdownVariants.TopNav
                : StandardNavLinkDropdownVariants.SideNav,
              colorMode: sideColorMode,
            }
          "
        />
      </ng-template>
    }

    @if (navSideHeaderTemplate || (navSideOverlayed() && showClose())) {
      <ng-template #header>
        @if (navSideOverlayed() && !navSideMinimized()) {
          <div class="d-flex flex-grow-1 align-items-center mx-2">
            @if (navSideHeaderTemplate) {
              <div>
                <ng-container
                  *ngTemplateOutlet="
                    navSideHeaderTemplate;
                    context: {
                      hasNavSide: hasNavSide(),
                      navSideExpanded: navSideExpanded(),
                      toggleNavSide: onToggleNavSide,
                      minimized: minimized,
                      colorMode: sideColorMode,
                    }
                  "
                />
              </div>
            }

            @if (showClose()) {
              @defer {
                <div class="ms-auto">
                  <standard-button
                    variant="secondary-link"
                    styleClass="btn-header-actions"
                    [icon]="faXmark"
                    i18n-standardTooltip
                    standardTooltip="Close"
                    (handleClick)="onToggleNavSide(false)"
                  />
                </div>
              }
            }
          </div>
        } @else {
          <ng-container
            *ngTemplateOutlet="
              navSideHeaderTemplate;
              context: {
                hasNavSide: hasNavSide(),
                navSideExpanded: navSideExpanded(),
                toggleNavSide: onToggleNavSide,
                minimized: minimized,
                colorMode: sideColorMode,
              }
            "
          />
        }
      </ng-template>
    }

    @if (navSidePreStartActionsTemplate) {
      <ng-template #preStartActions>
        <ng-container
          *ngTemplateOutlet="
            navSidePreStartActionsTemplate;
            context: {
              hasNavSide: hasNavSide(),
              navSideExpanded: navSideExpanded(),
              toggleNavSide: onToggleNavSide,
              minimized: minimized,
              variant: minimized
                ? StandardNavLinkDropdownVariants.TopNav
                : StandardNavLinkDropdownVariants.SideNav,
              colorMode: sideColorMode,
            }
          "
        />
      </ng-template>
    }

    @if (
      navSideStartActionsTemplate ||
      (widthCategory() !== undefined &&
        widthCategory()! <= topStartToSideStartMaxSize &&
        navTopStartActionsTemplate) ||
      (widthCategory() !== undefined &&
        widthCategory()! > MD &&
        navSideStartLargishOnlyActionsTemplate)
    ) {
      <ng-template #startActions>
        @if (
          widthCategory() !== undefined &&
          widthCategory()! > MD &&
          navSideStartLargishOnlyActionsTemplate
        ) {
          <ng-container
            *ngTemplateOutlet="
              navSideStartLargishOnlyActionsTemplate;
              context: {
                hasNavSide: hasNavSide(),
                navSideExpanded: navSideExpanded(),
                toggleNavSide: onToggleNavSide,
                minimized: minimized,
                variant: minimized
                  ? StandardNavLinkDropdownVariants.TopNav
                  : StandardNavLinkDropdownVariants.SideNav,
                colorMode: sideColorMode,
              }
            "
          />
        }

        @if (
          widthCategory() !== undefined &&
          widthCategory()! <= topStartToSideStartMaxSize
        ) {
          <ng-container
            *ngTemplateOutlet="
              navTopStartActionsTemplate;
              context: {
                hasNavSide: hasNavSide(),
                navSideExpanded: navSideExpanded(),
                toggleNavSide: onToggleNavSide,
                navSideMinimized: minimized,
                variant: minimized
                  ? StandardNavLinkDropdownVariants.TopNav
                  : StandardNavLinkDropdownVariants.SideNav,
                colorMode: sideColorMode,
              }
            "
          />
        }

        <ng-container
          *ngTemplateOutlet="
            navSideStartActionsTemplate;
            context: {
              hasNavSide: hasNavSide(),
              navSideExpanded: navSideExpanded(),
              toggleNavSide: onToggleNavSide,
              minimized: minimized,
              variant: minimized
                ? StandardNavLinkDropdownVariants.TopNav
                : StandardNavLinkDropdownVariants.SideNav,
              colorMode: sideColorMode,
            }
          "
        />
      </ng-template>
    }

    @if (
      navSideEndActionsTemplate ||
      (widthCategory() !== undefined &&
        widthCategory()! <= topEndToSideEndMaxSize &&
        navTopEndActionsTemplate) ||
      (widthCategory() !== undefined &&
        widthCategory()! <= MD &&
        navSideEndSmallishOnlyActionsTemplate)
    ) {
      <ng-template #endActions>
        @if (
          widthCategory() !== undefined &&
          widthCategory()! <= MD &&
          navSideEndSmallishOnlyActionsTemplate
        ) {
          <ng-container
            *ngTemplateOutlet="
              navSideEndSmallishOnlyActionsTemplate;
              context: {
                hasNavSide: hasNavSide(),
                navSideExpanded: navSideExpanded(),
                toggleNavSide: onToggleNavSide,
                minimized: minimized,
                variant: minimized
                  ? StandardNavLinkDropdownVariants.TopNav
                  : StandardNavLinkDropdownVariants.SideNav,
                colorMode: sideColorMode,
              }
            "
          />
        }

        <ng-container
          *ngTemplateOutlet="
            navSideEndActionsTemplate;
            context: {
              hasNavSide: hasNavSide(),
              navSideExpanded: navSideExpanded(),
              toggleNavSide: onToggleNavSide,
              minimized: minimized,
              variant: minimized
                ? StandardNavLinkDropdownVariants.TopNav
                : StandardNavLinkDropdownVariants.SideNav,
              colorMode: sideColorMode,
            }
          "
        />

        @if (
          widthCategory() !== undefined &&
          widthCategory()! <= topEndToSideEndMaxSize
        ) {
          <ng-container
            *ngTemplateOutlet="
              navTopEndActionsTemplate;
              context: {
                hasNavSide: hasNavSide(),
                navSideExpanded: navSideExpanded(),
                toggleNavSide: onToggleNavSide,
                navSideMinimized: minimized,
                variant: minimized
                  ? StandardNavLinkDropdownVariants.TopNav
                  : StandardNavLinkDropdownVariants.SideNav,
                colorMode: sideColorMode,
              }
            "
          />
        }
      </ng-template>
    }
  </standard-nav-side>
</ng-template>
